import { useState } from "react";
import { Upload, X } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, label }) {
  const [busy, setBusy] = useState(false);
  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Bild hochgeladen");
    } catch { toast.error("Upload fehlgeschlagen"); }
    finally { setBusy(false); }
  };
  return (
    <div>
      {label && <label className="text-xs uppercase tracking-widest text-slate-400">{label}</label>}
      <div className="mt-1.5 relative border border-dashed border-slate-300 aspect-[4/3] overflow-hidden bg-slate-50 grid place-items-center">
        {value ? (
          <>
            <img src={fileUrl(value)} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => onChange(null)} className="absolute top-2 right-2 bg-white p-1.5 shadow">
              <X size={16} />
            </button>
          </>
        ) : (
          <label className="cursor-pointer flex flex-col items-center gap-2 text-slate-500 p-4 text-center">
            <Upload size={22} />
            <span className="text-sm">{busy ? "Lädt…" : "Bild wählen"}</span>
            <input type="file" accept="image/*" className="hidden" onChange={handle} disabled={busy} />
          </label>
        )}
      </div>
    </div>
  );
}
